import type { Competition } from './data/competitions';
import type { RobotValues, RulePack } from './types';
import { loadJSON, storageKeys } from './storage';

/** Default robot values from the competition's config field definitions. */
export function defaultRobot(comp: Competition): RobotValues {
  const v: RobotValues = {};
  comp.configFields.forEach((f) => {
    v[f.key] = f.default;
  });
  return v;
}

/** Saved robot config merged over defaults. */
export function loadRobot(comp: Competition): RobotValues {
  return { ...defaultRobot(comp), ...loadJSON<RobotValues>(storageKeys.robot(comp.id), {}) };
}

/** Saved rule pack edits merged over the competition's default pack. */
export function loadRulePack(comp: Competition): RulePack {
  const stored = loadJSON<RulePack>(storageKeys.rulePack(comp.id), {});
  const merged: RulePack = {};
  for (const [section, fields] of Object.entries(comp.rulePack)) {
    merged[section] = { ...fields, ...(stored[section] ?? {}) };
  }
  return merged;
}
